<!-- 开放平台 -->
<template>
	<div id="app">
		<!-- <login></login> -->
		<router-view></router-view>
	</div>
</template>

<script>
	// import login from '@/page/login.vue'

	export default {
		name: 'app',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				alive: true
			}
		},
		// created() {
		// 	document.body.scrollTop = 0;
		// },
		methods: {
			reload() {
				this.alive = false;
				this.$nextTick(() => {
					this.alive = true;
				})
			},

		},
		components: {
			// login
		}
	}
</script>

<style>
	* {
		margin: 0;
		padding: 0;
	}

	#app {
		/* height: 100vh; */
	}

	/* 分辨率适配将px转化成rem 和px2rem-loader，lib-flexible搭配使用*/
	@media only screen and (min-width: 960px) {
		html {
			font-size: 8px !important;
		}
	}
	@media only screen and (min-width: 1097px) {
		html {
			font-size: 9px !important;
		}
	}
	@media only screen and (min-width: 1269px) {
		html {
			font-size: 10px !important;
		}
	}

	@media only screen and (min-width: 1522px) {
		html {
			font-size: 11px !important;
		}
	}

	@media only screen and (min-width: 1745px) {
		html {
			font-size: 13px !important;
		}
	}

	@media only screen and (min-width: 1920px) {
		html {
			font-size: 15px !important;
		}
	}

	@media only screen and (min-width: 2133px) {
		html {
			font-size: 17px !important;
		}
	}

	@media only screen and (min-width: 2400px) {
		html {
			font-size: 19px !important;
		}
	}

	@media only screen and (min-width: 2560px) {
		html {
			font-size: 20px !important;
		}
	}

	@media only screen and (min-width: 2880px) {
		html {
			font-size: 22px !important;
		}
	}

	@media only screen and (min-width: 3840px) {
		html {
			font-size: 30px !important;
		}
	}
</style>
